function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M29.6937 4.32432C30.0781 3.89189 30.4625 3.89189 30.8468 4.32432L31.7117 5.11712C32.0961 5.54955 32.0961 5.95796 31.7117 6.34234L10.0901 27.964C9.65766 28.3964 9.24925 28.3964 8.86487 27.964L0.288288 19.3874C-0.0960961 19.003 -0.0960961 18.5946 0.288288 18.1622L1.15315 17.3694C1.2973 17.1772 1.48949 17.0811 1.72973 17.0811C1.96997 17.0811 2.16216 17.1772 2.30631 17.3694L9.44144 24.5045L29.6937 4.32432Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5b7524775857085eee32213598c394c2.svg";
export { ForwardRef as ReactComponent };